module.exports = __webpack_public_path__ + "static/media/arjeplogvapen.23ae4f8c.png";